const Ui = location.search.includes("pipDebug");
import { isCameraMuted, isMicMuted, kinoParticipants, room, screenShare, toggleCamera, toggleMic, Video } from '../../libs/roomnew';
import { updateVideoQuality } from '../base/video-quality/actions';
import {
    CLEAR_TIMEOUT,
    TIMEOUT_TICK,
    SET_TIMEOUT,
    timerWorkerScript
} from './TimerWorker';
export default class Pip{
    constructor(){
        this.togglePipButton=$("#togglePictureInPicture");
        this.canvas;
        this.video;
        this.fps=15;
        this.users=[];
        this.dpr=window.devicePixelRatio || 1;
        this.ready=0;
        this.started=0;
        this.layout=null;
        this.timerWorker;
        this.timer={
            start:()=>{},
            stop:()=>{}
        };
        this.enterPipIcon=`<?xml version="1.0" ?><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M2 6.25C2 4.45507 3.45507 3 5.25 3H18.75C20.5449 3 22 4.45507 22 6.25V12H20.5V6.25C20.5 5.2835 19.7165 4.5 18.75 4.5H5.25C4.2835 4.5 3.5 5.2835 3.5 6.25V15.75C3.5 16.7165 4.2835 17.5 5.25 17.5H11V19H5.25C3.45507 19 2 17.5449 2 15.75V6.25ZM14 13C12.8954 13 12 13.8954 12 15V20C12 21.1046 12.8954 22 14 22H21C22.1046 22 23 21.1046 23 20V15C23 13.8954 22.1046 13 21 13H14ZM5.21967 6.21967C5.51256 5.92678 5.98744 5.92678 6.28033 6.21967L9.5 9.43934V7.75C9.5 7.33579 9.83579 7 10.25 7C10.6642 7 11 7.33579 11 7.75V11.25C11 11.6642 10.6642 12 10.25 12H6.75C6.33579 12 6 11.6642 6 11.25C6 10.8358 6.33579 10.5 6.75 10.5H8.43934L5.21967 7.28033C4.92678 6.98744 4.92678 6.51256 5.21967 6.21967Z"/></svg>`;
        this.exitPipIcon=`<?xml version="1.0" ?><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 11C11.1046 11 12 10.1046 12 9V4C12 2.89543 11.1046 2 10 2H3C1.89543 2 1 2.89543 1 4V9C1 9.75939 1.42323 10.4199 2.04668 10.7586C2.33007 10.9126 2.65482 11 3 11H10ZM18.75 6.5H13V5H18.75C20.5449 5 22 6.45508 22 8.25V17.75C22 19.5449 20.5449 21 18.75 21H5.25C3.45507 21 2 19.5449 2 17.75V11.8293C2.31278 11.9398 2.64936 12 3 12H3.5V17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H18.75C19.7165 19.5 20.5 18.7165 20.5 17.75V8.25C20.5 7.2835 19.7165 6.5 18.75 6.5ZM15.9393 16H14.25C13.8358 16 13.5 16.3358 13.5 16.75C13.5 17.1642 13.8358 17.5 14.25 17.5H17.75C18.1642 17.5 18.5 17.1642 18.5 16.75V13.25C18.5 12.8358 18.1642 12.5 17.75 12.5C17.3358 12.5 17 12.8358 17 13.25V14.9393L14.2803 12.2197C13.9874 11.9268 13.5126 11.9268 13.2197 12.2197C12.9268 12.5126 12.9268 12.9874 13.2197 13.2803L15.9393 16Z"/></svg>`;
        // this._reset();
    };

buttonEvent(){
    this.togglePipButton.on('click',()=>{
        if(this.started){
            this.stop();
        }else{
            this.start();
        }
    });
    this._reset();
}

isPIP(){
    return this.started;
}

updatePipButton(pipOn){
    if(pipOn){
        this.togglePipButton.find(".kinetx-icon").html(this.exitPipIcon);
        this.togglePipButton.attr('data-original-title',"Exit Picture in Picture");
    }else{
        this.togglePipButton.find(".kinetx-icon").html(this.enterPipIcon);
        this.togglePipButton.attr('data-original-title',"Enter Picture in Picture");
    }
};

initTimerWorker(){
    let pip=this;
    this.timerWorker = new Worker(timerWorkerScript, { name: 'PiP worker' });
    this.timerWorker.onmessage=this._draw.bind(pip);
    this.timer={
        start:()=>{
            this.timerWorker.postMessage({
                id: SET_TIMEOUT,
                timeMs: 1000 / this.fps
            });
        },
        stop:()=>{
            this.timerWorker.postMessage({
                id: CLEAR_TIMEOUT
            });
        }
    }
}

terminateTimerWorker(){
    if(!this.timerWorker){return}
    this.timerWorker.terminate();
    this.timerWorker=null;
    this.timer={
        start:()=>{},
        stop:()=>{}
    };
};

start(){
    if(this.ready){
        this.updateUsers(kinoParticipants.inSameSpace());
        if(document.pictureInPictureElement){
            document.exitPictureInPicture();
        }
        this._play().then(()=>{
            this.video.requestPictureInPicture();
        }).catch(err=>{
            console.error(`Failed to play pip video`,err)
        });
    }else{
        console.warn("Not ready, please try again");
    }
};

stop(){
    document.exitPictureInPicture()
    .then(() => this._onleavepictureinpicture())
    .catch((err) => console.error(err))
};

setCanvasSize(){
    if(this.ready){
        this.canvas.width = Math.round(this.layout.width);
        this.canvas.height = Math.round(this.layout.height);
    }else{
        this.canvas.width = 50;
        this.canvas.height = Math.round(this.canvas.width / (16/9));
    }
};

updateUsers(users) {
    this.users = users.length == 2 ? users.reverse() : users;

    this._updateLayout()
};

_updateLayout() {
    this.layout = this.createLayout({
        width: 600 * this.dpr,
        cellAspectRatio: 16/9,
        cellCount: this.users.length
    })
}

initDOM(){
    let pip=this;
    this.canvas = document.createElement("canvas");
    window.mycanvas = this.canvas;
    this.setCanvasSize();
    this.ctx = this.canvas.getContext("2d",{willReadFrequently: true});
    this.ctx.fillStyle = "#000";
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.video = document.createElement("video");
    this.video.muted = 1;
    this.video.autoplay = 1;
    this.video.playsinline = 1;
    if(Ui){
        this.canvas.setAttribute("style", "position: fixed; top: 0; left: 0; pointer-events: none;");
        document.body.appendChild(this.canvas);
    }
    document.body.appendChild(this.video);
    this.video.setAttribute("style", `position: fixed; right: 0; bottom: -350px; pointer-events: none; opacity: ${Ui?1:0};`);
    this.video.addEventListener("loadedmetadata", this._onloadedmetadata.bind(pip));
    this.video.addEventListener("enterpictureinpicture", this._onenterpictureinpicture.bind(pip));
    this.video.addEventListener("leavepictureinpicture", this._onleavepictureinpicture.bind(pip));
    this.video.srcObject = this.canvas.captureStream(this.fps);

};

removeDOMEvents(){
    let pip=this;
    if(this.video){
        this.video.removeEventListener("loadedmetadata", this._onloadedmetadata.bind(pip));
        this.video.removeEventListener("enterpictureinpicture", this._onenterpictureinpicture.bind(pip));
        this.video.removeEventListener("leavepictureinpicture", this._onleavepictureinpicture.bind(pip));
        this.video.remove();
        Ui && this.canvas.remove();
        this.video = null;
        this.canvas = null;
        this.ctx = null;
    }
}

_onloadedmetadata() {
    if(!this.ready){
        this.ready = true;
        this.timer.stop()
    }
}
_onenterpictureinpicture() {
    this.started = true;
    this.updatePipButton(true);
    // room.setREce
    // Video.setQuality(360);
    updateVideoQuality(360);
    setTimeout(() => {
        this.addPIPControls();
    }, 500);
}
_onleavepictureinpicture() {
    console.log("on PIP Exit")
    this.started = false
    updateVideoQuality(720)
    this._pause();
    this.updatePipButton(false);
    this.onLeavePictureInPicture();
    this._reset()
}
onLeavePictureInPicture(){
    // this.teardown();
    this.terminateTimerWorker();
};

_reset() {
    this.ready = false;
    this.started = false;
    this.removeDOMEvents();
    this.initDOM();
    this.timer.start();
}

_play() {
    this.setCanvasSize();
    this.initTimerWorker();
    this.timer.start();
    return this.video.play();
}
_pause() {
    this.timer.stop();
    this.video.load()
}

teardown(){
    this.started && this.stop();
    this.terminateTimerWorker();
    this.users = [];
    this.ready = false;
    this.started = false;
    this.removeDOMEvents();
};

_draw(){
    this.ctx.fillStyle = "#000";
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    if(this.started){
        if(this.users.length){
            this.users.forEach((user,index) => {
                let video = document.getElementById(user.local ? 'localVideo1' : `${user.id}-media-player`);
                let isDesktop=user.local && screenShare.isSharing();
                let userFlipVideo=$("#flipCameraControlOption").is(':checked');
                if(user.local && screenShare.isSharing() && screenShare.cameraStream && screenShare.cameraPreview){
                    video=screenShare.cameraPreview;
                    isDesktop=false;
                }
                if(!video){
                    return console.warn("Pip _draw: missing video for participant id", user.id);
                }
                const rectangle=this.layout.cellRects[index];
                if(!rectangle){return}

                let posX=rectangle.origin.x;
                let flipVideo=user.local && !isDesktop && (video.classList.contains('flipVideoX') || userFlipVideo);
                if(flipVideo){
                    this.ctx.save();
                    this.ctx.translate(this.canvas.width, 0);
                    this.ctx.scale(-1, 1);
                    posX = this.users.length == 2 ? 0 : Math.round(this.canvas.width - rectangle.bounds.width + rectangle.origin.x);
                    // this.ctx.strokeStyle = '#1e6e8a';
                    // this.ctx.lineWidth = 2;
                }
                this.drawVideo({
                    ctx: this.ctx,
                    video: video,
                    posx: posX,
                    posy: rectangle.origin.y,
                    width: rectangle.bounds.width,
                    height: rectangle.bounds.height,
                    objectFit: video.videoWidth > video.videoHeight ? "cover" : "contain"
                });

                if(flipVideo){
                    this.ctx.restore();
                }

            });
        }else{
            //no cameras
            this.ctx.font = 16 * this.dpr + "px system-ui, -apple-system, sans-serif";
            this.ctx.textAlign = "center";
            this.ctx.textBaseline = "middle";
            this.ctx.fillStyle = "#fff";
            this.ctx.fillText("No camera on", this.canvas.width / 2, this.canvas.height / 2);
        }
    }
};

drawVideo(data){
    let {
        ctx,
        video,
        posx,
        posy,
        width,
        height,
        objectFit
    } = data;

    let offsetX = .5;
    let offsetY = .5;

    let videoWidth = video.videoWidth;
    let videoHeight = video.videoHeight;
    let zoomFactor = Math["cover" === objectFit ? "max" : "min"](width / videoWidth, height / videoHeight);
    let sourceWidth =  videoWidth / (videoWidth * zoomFactor / width);
    let sourceHeight = videoHeight / (videoHeight * zoomFactor / height);
    let sourceX = (videoWidth - sourceWidth) * offsetX;
    let sourceY = (videoHeight - sourceHeight) * offsetY;
    // ctx.strokeRect(posx, posy, width,width,height);
    ctx.drawImage(video,sourceX,sourceY,sourceWidth,sourceHeight,posx,posy,width,height);

};

createLayout(options) {
    const height = Math.round(options.width / options.cellAspectRatio);
    const width = Math.round(options.width);
    if(options.cellCount <= 1 ){
        return {
            width: width,
            height: height,
            cellRects: [{
                origin: {
                    x: 0,
                    y: 0
                },
                bounds: {
                    width: width,
                    height: height
                }
            }],
            cellCount: options.cellCount
        };
    }else{
        const cells = Math.min(options.cellCount, 25);
        let columns = 0;
        let rows = 0;
        if(cells <= 2){
            columns=1;rows=1;
        }else if(cells<=4){
            columns=2;rows=2;
        }else if(cells <= 6){
            columns=3;rows=2;
        }else if(cells <= 9){
            columns=3;rows=3;
        }else if(cells <= 12){
            columns=4;rows=3;
        }else if(cells <= 16){
            columns=4;rows=4;
        }else if(cells <= 20){
            columns=5;rows=4;
        }else{
            columns=5;rows=5;
        }
        const cellBounds = {
            width: Math.round(width / columns),
            height: Math.round(height / rows)
        };
        const localVideoBounds = {
            width: Math.round(width * 0.3),
            height: Math.round((width * 0.3)/1.77777)
        };
        const lastRow=cells % columns;
        const emptyCells=lastRow > 0 ? columns - lastRow : 0;
        const Xoffset=Math.round(emptyCells*cellBounds.width/2);
        const lastRowStartIdx=cells-lastRow;
        const cellRects = [...Array(cells)].map((e, index) => ({
            origin: {
                x: index >= lastRowStartIdx ? (Math.floor(index % columns) * cellBounds.width)+ Xoffset : cells==2 && index==1 ? (width - localVideoBounds.width)-2 : Math.floor(index % columns) * cellBounds.width ,
                y: cells==2 && index==1  ?  (height - localVideoBounds.height)-2 : Math.floor(index / columns) * cellBounds.height
            },
            bounds: cells==2 && index==1 ? localVideoBounds : cellBounds
        }));
        return {
            width: cellBounds.width * columns,
            height: cellBounds.height * rows,
            cellRects: cellRects,
            cellCount: cells
        };
    }
};
addPIPControls(){
    try {
        console.log("Adding mediasession handlers")
        navigator.mediaSession.setActionHandler("togglemicrophone", () => {
            toggleMic();
        });
        navigator.mediaSession.setMicrophoneActive(!isMicMuted())
    } catch (i) {
        console.error(i)
    }
    try {
        navigator.mediaSession.setActionHandler("togglecamera", () => {
            toggleCamera();
        });
        navigator.mediaSession.setCameraActive(!isCameraMuted())
    } catch (i) {
        console.error(i)
    }
    // try {
    //     navigator.mediaSession.setActionHandler("hangup", () => {
    //         o.doLeaveRoom({
    //             context: "pip"
    //         })
    //     })
    // } catch (i) {
    //     console.error(i)
    // }
};

setCameraActive(active){
    try {
        if(!this.started){return}
        navigator.mediaSession.setCameraActive(active);
    } catch (error) {
        console.error(error)
    }
};

setMicrophoneActive(active){
    try {
        if(!this.started){return}
        navigator.mediaSession.setMicrophoneActive(active);
    } catch (error) {
        console.error(error)
    }
};

};
